import React from 'react';
import { Link } from 'react-router-dom';

interface ServiceHighlightProps {
  title: string;
  description: string;
  image: string;
  isReversed?: boolean;
}

const ServiceHighlight: React.FC<ServiceHighlightProps> = ({ 
  title, 
  description, 
  image, 
  isReversed = false 
}) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${isReversed ? 'md:flex-row-reverse' : ''}`}>
      <div className={`${isReversed ? 'md:order-2' : ''}`}>
        <div className="rounded-lg overflow-hidden h-64 md:h-96">
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className={`${isReversed ? 'md:order-1' : ''} bg-black p-8 rounded-lg`}>
        <h3 className="section-title">{title}</h3>
        <p className="text-white mb-6">{description}</p>
        <Link to="/contact" className="btn-primary inline-block">
          Get a Quote
        </Link>
      </div>
    </div>
  );
};

export default ServiceHighlight;